module.exports = {
      id: "account-password-usage",
      viewBox: "0 0 16.4 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-password-usage",
      toString: function () {
        return this.url;
      }
    }